package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the SEO page: the service, the breadcrumb and the FAQ. */
@Composable
fun seoStructuredData(): String {
    val description = LocalText(RdText.SEO_META_DESCRIPTION)
    val breadcrumb = rdBreadcrumbJsonLd(RdText.SEO_CRUMB, RdRoute.SEO)
    val faq = rdFaqJsonLd(SeoFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"Service","name":"SEO services for sole trader websites","serviceType":"Search engine optimisation",
          "areaServed":"GB","url":"$SITE_URL${RdRoute.SEO}","description":${jsonString(description)},
          "provider":{"@id":"$SITE_URL/#business"}},
         $breadcrumb,
         $faq
        ]}
    """.trimIndent()
}
